export const BRAND_CONTACTS = {
  allstate: {
    email: 'ampet@embracepetinsurance.com',
    phone: '844-428-3678'
  },
  embrace: {
    email: 'hello@embracepetinsurance.com',
    phone: '800-643-7578'
  },
  geico: {
    email: 'geico@embracepetinsurance.com',
    phone: '844-428-1679'
  },
  usaa: {
    email: 'usaa@embracepetinsurance.com',
    phone: '844-392-4549'
  }
}
